import React from 'react';
import PropTypes from 'prop-types';
import PrettyIcon from '../PrettyIcon/PrettyIcon';
import ChevronLeft from '../Svg/ChevronLeft';
import styles from './FaderTitle.scss';
import classNames from 'classnames';
import Fader from './Fader';

class WithBackButton extends React.Component {
  state = { isMounted: false };
  animationFrame = null;

  componentDidMount() {
    this.animationFrame = requestAnimationFrame(() => {
      this.setState({ isMounted: true });
    });
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animationFrame);
  }

  render() {
    const { content, onBackClick } = this.props;
    const { isMounted } = this.state;
    const contentClassName = classNames([styles.content, isMounted && styles.mounted]);
    const buttonClassName = classNames([styles.button, isMounted && styles.mounted]);

    const button = (
      <PrettyIcon onClick={onBackClick} className={buttonClassName} data-hook="fader-title-back">
        <ChevronLeft />
      </PrettyIcon>
    );

    return (
      <div className={styles.secondaryWrapper}>
        {button}
        <div className={contentClassName}>{content}</div>
      </div>
    );
  }
}

WithBackButton.displayName = 'WithBackButton';
WithBackButton.propTypes = {
  content: PropTypes.string,
  onBackClick: PropTypes.func,
};

class Primary extends React.Component {
  state = { isMounted: false };
  animationFrame = null;

  componentDidMount() {
    this.animationFrame = requestAnimationFrame(() => {
      this.setState({ isMounted: true });
    });
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animationFrame);
  }

  render() {
    const { content, isFirstTransition } = this.props;
    const { isMounted } = this.state;
    const primaryClassName = classNames([styles.primaryWrapper, isMounted && styles.mounted, !isFirstTransition && styles.withTransition]);

    return <div className={primaryClassName}>{content}</div>;
  }
}

Primary.displayName = 'Primary';
Primary.propTypes = {
  content: PropTypes.string,
  isFirstTransition: PropTypes.bool,
};

export default class FaderTitle extends React.Component {
  state = { isFirstTransition: true };

  _onBackClick = () => {
    this.setState({ isFirstTransition: false }, () => {
      this.props.onBackClick();
    });
  };

  render() {
    const { isFirstTransition } = this.state;
    const { primary, secondary, drilldown, displayBackButton } = this.props;

    const wrappedPrimary = <Primary content={primary} isFirstTransition={isFirstTransition} />;

    const wrappedSecondary = displayBackButton ? (
      <WithBackButton content={secondary} onBackClick={this._onBackClick} />
    ) : (
      secondary
    );

    return <Fader primary={wrappedPrimary} secondary={wrappedSecondary} drilldown={drilldown} />;
  }
}

FaderTitle.displayName = 'FaderTitle';
FaderTitle.propTypes = {
  primary: PropTypes.string,
  secondary: PropTypes.string,
  drilldown: PropTypes.bool,
  displayBackButton: PropTypes.bool,
  onBackClick: PropTypes.func,
};
FaderTitle.defaultProps = {
  displayBackButton: true,
};
